import { z } from 'zod';
import { objectIdSchema } from './objectId';
import { GroupResourceType } from './const';

export const GroupResourceSchema = z.object({
  _id: objectIdSchema,
  resourceType: z.enum(GroupResourceType),
  price: z.number().min(0),
  name: z.string(),
  archived: z.boolean(),
  properties: objectIdSchema.array(),
  source: objectIdSchema,
});

export const GroupResourceBaseSchema = GroupResourceSchema.omit({
  _id: true,
}).extend({
  properties: z.string().array(),
  source: z.string(),
});

export type GroupResource = z.infer<typeof GroupResourceSchema>;
export type GroupResourceBase = z.infer<typeof GroupResourceBaseSchema>;
